export const LoaderRing = ({colorLoader}) => {
    return (
      <div className="min-h-full flex justify-center items-center">
        <div className={`h-5 w-5 animate-spin rounded-full border-2 ${colorLoader}`} />
      </div>
    );
  };